import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-right',
  imports: [],
  templateUrl: './chevron-right.html',
  styleUrl: './chevron-right.css'
})
export class ChevronRight {

}
